import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import main from '../../main';
import { getSafeLandingLink } from '../../utils/landingPage';
import { showToast } from '../../utils/utils';

interface NavItem {
  path: string;
  label: string;
  icon: string;
  iconActive: string;
}
const navList: NavItem[] = [
  {
    path: '/',
    label: '首页',
    icon: '/pic/icon_nav_home.png',
    iconActive: '/pic/icon_nav_home_active.png',
  },
  {
    path: '/customer',
    label: '客服',
    icon: '/pic/icon_nav_customer.png',
    iconActive: '/pic/icon_nav_customer_active.png',
  },
  {
    path: '/order',
    label: '订单',
    icon: '/pic/icon_nav_search.png',
    iconActive: '/pic/icon_nav_search_active.png',
  },
];
export default function BottomNavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectTab, setSelectTab] = useState(navList[0]);

  useEffect(() => {
    let idx = navList.findIndex((item) => item.path === location.pathname);
    if (idx >= 0) {
      setSelectTab(navList[idx]);
    }
  }, [location]); // eslint-disable-line

  function handleSelectTab(v: NavItem) {
    if (v.path === '/customer') {
      if (!main.landingApiModeResolved) {
        // 客服链接随落地页配置返回；慢网时禁止把“尚未返回”误判成“未配置”。
        showToast('页面配置加载中，请稍后再试');
        return;
      }
      const serviceLink = getSafeLandingLink(main.serviceLink);
      if (serviceLink) {
        // 必须保留在用户点击的同步调用栈中，避免企业微信等客服链接被浏览器当作弹窗拦截。
        // 同时不再使用 iframe，规避客服站点的 X-Frame-Options/CSP 导致空白页。
        window.open(serviceLink, '_blank', 'noopener,noreferrer');
        return;
      }
    }
    setSelectTab(v);
    navigate(v.path);
  }

  return (
    <div className="bottom-nav-bar d-flex-c">
      <div className="bottom-nav-bar-content ">
        <Outlet />
      </div>
     {
      !main?.from &&  <div className="bottom-nav-bar-bottom border-top d-flex-r ai-center">
      {navList.map((i) => (
        <div key={i.label} className="bottom-nav-bar-item text-center flex-1" onClick={() => handleSelectTab(i)}>
          <img className="icon" src={selectTab.path === i.path ? i.iconActive : i.icon} alt="" />
          <div className={`font-size-12 ${selectTab.path === i.path ? 'text-color-p' : 'text-color-9'}`}>
            {i.label}
          </div>
        </div>
      ))}
    </div>
     }
    </div>
  );
}
